import {utils} from '@wallaby-ui/core';

import {CHART_REDUCER_STATE_ID} from './chart_constants';
import {chartSlice} from './chart_slice';

export const getReducers = (key) => ({
  [utils.reducerUtils.getInstanceReducerId(CHART_REDUCER_STATE_ID, key)]:
    utils.reducerUtils.createFilteredReducer(
      chartSlice.reducer,
      (action) =>
        (action.stateId ?? action.meta?.stateId) ===
        utils.reducerUtils.getInstanceReducerId(CHART_REDUCER_STATE_ID, key)
    ),
});
